/* Function to add partner details*/
function addPartnerBlock(response) {
    const firstName = response.FirstName;
    const lastName = response.LastName;
    if (firstName.toLowerCase() !== "orphan" && lastName.toLowerCase() !== "account") {
        document.querySelectorAll('.partner-container').forEach(elm => elm.classList.remove("display-none"));
        document.querySelectorAll('.partner-info-container').forEach(elm => elm.innerHTML = firstName + ' ' + lastName);
    }
}
  
/* Function to fetch parter api response and store in localStorage */
async function fetchPartnerInfo(url, type, id, retryCount) {
    let updatedURL = url + "&" + type + "=" + id
    if (retryCount === 0) return null;
    try {
        console.log(`Fetching partner info from URL: ${updatedURL}`);
        const response = await fetch(updatedURL)

        if (!response.ok) {
            console.log(`Fetch failed, retrying... (${retryCount - 1} retries left)`);
            return await fetchPartnerInfo(url, type, id, retryCount - 1);
        } else if (response.status === 204) {
            console.log('No content returned from API (204)');
            return null;
        }

        const responseBody = await response.json();
        if (responseBody.error) {
            console.log('Error in response body:', responseBody.error);
            return null;
        }
        console.log('Fetched partner info:', responseBody);
        localStorage.setItem('partnerInfo', JSON.stringify(responseBody));
        sessionStorage.setItem('lastCommSysPartnerID', responseBody.commSysPartnerID);
        return responseBody;
    } catch (error) {
        console.log('Failed to process partner information' + error);
        return await fetchPartnerInfo(url, type, id, retryCount - 1);
    }
}

/* Get partner information from local storage */
function getPartnerDetailsFromLocalStorage() {
    let partnerLocalDetails = localStorage.getItem('partnerInfo');
    if (partnerLocalDetails && partnerLocalDetails !== null) {
        try {
            console.log('Retrieved partner info from localStorage:', partnerLocalDetails);
            return JSON.parse(partnerLocalDetails);
        } catch (error) {
            console.log('Failed to parse partner local storage data' + error);
        }
    }
    return null;
}

function getUrlParams() {
    let urlParams = new URLSearchParams(window.location.search);
    const isFromCheckout = urlParams.has('checkout_url');
    console.log("isFromCheckout:", isFromCheckout);
    if (isFromCheckout) {
        const checkoutUrlEncoded = getCheckoutUrl();
        const urlDecoded = decodeURIComponent(checkoutUrlEncoded);
        urlParams = new URLSearchParams(urlDecoded.split('?')[1]);
    }
    return urlParams;
}

function getAssociatedPartnerId() {
    const partnerDetails = getPartnerDetailsFromLocalStorage();
    const urlParams = getUrlParams();
    const commSysPartnerID = partnerDetails?.commSysPartnerID || urlParams.get('commSysPartnerID') || "";
    console.log('Associated commSysPartnerID:', commSysPartnerID);
    return commSysPartnerID;
}

const initPartner = async () => {
    let retryCount = 1;
    const accountContainer = document.querySelector('#site-header a.area--account');
    const isLoggedIn = accountContainer.getAttribute('data-logged-in');
    const urlParams = getUrlParams();
    const commSysPartnerIdParam = urlParams.get('commSysPartnerID');
    let partnerDetails = null;

    console.log('Initializing partner info...');
    console.log('Is logged in:', isLoggedIn);
    console.log('commSysPartnerID param:', commSysPartnerIdParam);

    if (isLoggedIn === 'true') {
        const customerId = accountContainer.getAttribute('data-customer-id');
        console.log('Customer ID:', customerId);
        partnerDetails = await fetchPartnerInfo(
            KROWN.settings.partner.get_partner_by_customer_id_url,
            "cartCustomerID",
            customerId,
            retryCount
        );
        if (!partnerDetails && window.sessionStorage.getItem('customerRegistrationSession') === 'true') {
            // Get the last loaded partner info if user completed the registration during the current session
            // and partner has not been associated in Exigo yet
            console.log('Fetching partner info from localStorage due to customer registration session');
            partnerDetails = getPartnerDetailsFromLocalStorage();
        }
    } else if (commSysPartnerIdParam) {
        let lastCommSysPartnerID = sessionStorage.getItem('lastCommSysPartnerID');
        console.log('Last commSysPartnerID from sessionStorage:', lastCommSysPartnerID);
        if (lastCommSysPartnerID && commSysPartnerIdParam !== lastCommSysPartnerID) {
            console.log('Removing outdated partner info from localStorage');
            localStorage.removeItem("partnerInfo");
        }
        partnerDetails = await fetchPartnerInfo(
            KROWN.settings.partner.get_partner_by_partner_id_url,
            "commSysPartnerID",
            commSysPartnerIdParam,
            retryCount
        );
    } else {
        console.log('Fetching partner info from localStorage');
        partnerDetails = getPartnerDetailsFromLocalStorage();
    }
    if (partnerDetails) {
        console.log('Adding partner block with details for partner:', partnerDetails);
        addPartnerBlock(partnerDetails);
    } else {
        console.log('Failed to fetch partner information at initPartner');
    }

    document.querySelector('.customer-logout')?.addEventListener('click', () => {
        console.log('Customer logged out, clearing partner info');
        localStorage.removeItem("partnerInfo");
        sessionStorage.removeItem("customerRegistrationSession");
    });
}

document.addEventListener("DOMContentLoaded", () => initPartner());
